import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { TENANT_PARAM } from '@/constants/countries';
import { ROUTE } from '@/constants/routes';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import MinorTriggeredByAdult from '@/pages/onboarding/minor-triggered-by-adult/MinorTriggeredByAdult';
import SessionExpiredPage from '@/pages/session-expired';

import { setUserSelectedLanguage } from '@/redux/ui/actions';

import IdentifyCustomerPage from '../../mobile-adoption/identify-customer';
import VerifyOTPPage from '../../mobile-adoption/verify-otp';
import CountrySelectionPage from '../../onboarding/country-select/CountrySelectionPage';
import EmailOTPPage from '../../onboarding/email-verification';
import LanguageSelectionPage from '../../onboarding/language-selection/LanguageSelectionPage';
import PreApprovedStatusPage from '../../onboarding/pre-approved-status/PreApprovedStatusPage';
import RemediationPage from '../../remediation/Remediation';

export function UnauthenticatedPage() {
  const { language } = useTranslate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setUserSelectedLanguage(language));
  }, [dispatch, language]);

  return (
    <Routes>
      <Route path={ROUTE.ONBOARDING} element={<CountrySelectionPage />}>
        <Route path={`:${TENANT_PARAM}`} element={<CountrySelectionPage />} />
      </Route>
      <Route path={ROUTE.REMEDIATION} element={<RemediationPage />}>
        <Route path={`:${TENANT_PARAM}`} element={<RemediationPage />} />
      </Route>
      <Route
        path={ROUTE.COUNTRY_SELECTION}
        element={<CountrySelectionPage />}
      />
      <Route
        path={ROUTE.LANGUAGE_SELECTION}
        element={<LanguageSelectionPage />}
      />
      <Route path={ROUTE.LOGIN_VERIFY_EMAIL} element={<EmailOTPPage />} />
      <Route
        path={ROUTE.MOBILE_ADOPTION_VERIFY_OTP}
        element={<VerifyOTPPage />}
      />
      <Route
        path={ROUTE.MOBILE_ADOPTION_IDENTIFY_CUSTOMER}
        element={<IdentifyCustomerPage />}
      />
      <Route
        path={ROUTE.LOGIN_PRE_APPROVED_STATUS}
        element={<PreApprovedStatusPage />}
      />
      <Route
        path={ROUTE.MINOR_TRIGGERED_BY_ADULT}
        element={<MinorTriggeredByAdult />}
      />
      <Route path={ROUTE.SESSION_EXPIRED} element={<SessionExpiredPage />} />
      <Route path="*" element={<Navigate to={ROUTE.COUNTRY_SELECTION} />} />
    </Routes>
  );
}
